export interface QuizQuestion {
  id: string;
  text: string;
  hint: string;
  options: {
    value: string;
    label: string;
    score: number;
  }[];
}

export interface QuizResult {
  tier: 'starter' | 'strategist' | 'leader';
  score: number;
  title: string;
  subtitle: string;
  message: string;
  quickWins: string[];
  cta: string;
  ctaSubtext: string;
}

// Scoring: 0-3 points per question, max 21 points
export const calculateScore = (answers: Record<string, string>): number => {
  const scores: Record<string, number> = {
    'a': 0,
    'b': 1,
    'c': 2,
    'd': 3,
  };
  
  return Object.values(answers).reduce((total, answer) => {
    return total + (scores[answer] || 0);
  }, 0);
};

export const getResultTier = (score: number): 'starter' | 'strategist' | 'leader' => {
  if (score <= 7) return 'starter';
  if (score <= 14) return 'strategist';
  return 'leader';
};

// Questions use translation keys from quiz.questions.q1, etc.
export const QUIZ_QUESTIONS: string[] = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7'];
